import { gql } from '@apollo/client'

export const Query = gql`
  query EditVenue($companyId: ID!, $filters: VenueFilters) {
    venues(companyId: $companyId, filters: $filters) {
      nodes {
        id
        address1
        address2
        address3
        city
        county
        postcode
        name
        notes
        map {
          url
        }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
